// src/components/research/note.js

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/* One sentence attached to the line above it.
   ------------------------------------------------------------------------
   The lightest of the three set-aside shapes; see callout.js for the full set
   and the rule for choosing between them. A Note is small enough to sit
   inside a list item without turning the list into a stack of panels, which
   is the whole reason it exists separately from Callout.

   The label is optional and has no default. Most notes are obviously an
   example of the line they hang off and naming that adds nothing; a note that
   is a different kind of support says so. It is set in the accent, like the
   Callout tab, so the two read as the same family at different weights. */
const StyledNote = styled.div`
  margin: var(--space-3) 0 0;
  padding-left: var(--space-4);
  border-left: 2px solid var(--border-strong);
  color: var(--text-muted);
  font-size: var(--fz-md);
  line-height: var(--lh-body);

  .label {
    display: block;
    margin-bottom: 2px;
    color: var(--accent);
    font-family: var(--font-sans);
    font-size: var(--fz-xxs);
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    max-width: none;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
  }
`;

const Note = ({ label, children }) => (
  <StyledNote>
    {label ? <span className="label">{label}</span> : null}
    {children}
  </StyledNote>
);

Note.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Note;
